import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { Box } from '@mui/material';
import { numberFormatOptions } from 'utils/formatOptions';

function PriceComponent({ value, numberFormat, fallBackText }) {
  return (
    <Box component="span">
      {value !== 0 && !Number.isNaN(value) ? (
        <FormattedNumber value={value} {...numberFormat} />
      ) : (
        fallBackText
      )}
    </Box>
  );
}

PriceComponent.propTypes = {
  value: PropTypes.number.isRequired,
  numberFormat: PropTypes.instanceOf(Object),
  fallBackText: PropTypes.string,
};

PriceComponent.defaultProps = {
  numberFormat: numberFormatOptions,
  fallBackText: '-',
};

export default PriceComponent;
